// templates/creative_preview/*
import creativePreviewHomeTpl from '../templates/creative_preview/home.html';
import creativePreviewLayoutTpl from '../templates/creative_preview/layout.html';
import creativePreviewSharedTpl from '../templates/creative_preview/shared.html';
import creativePreviewSavedTpl from '../templates/creative_preview/saved.html';

// enhanced ads templates
import enhancedAdsIndexTpl from '../enhanced_ads/index.html';
import enhancedAdsShowTpl from '../enhanced_ads/show.html';
import enhancedExampleTpl from '../enhanced_ads/example.html';

// templates/dsp/*
import dspHomeTpl from '../templates/dsp/home.html';
import dspShowTpl from '../templates/dsp/show.html';

const fetchCreative = [
  '$stateParams',
  'DataService',
  ({ id }, DataService) => DataService.getCreative(id).catch(() => ({}))
];

const fetchCreativeGroup = [
  '$stateParams',
  '$http',
  ({ id }, $http) => $http.get(`/creative_groups/${id}`).catch(() => ({}))
];

const fetchCurrentPartner = [
  'CurrentPartnerService',
  CurrentPartnerService => CurrentPartnerService.get()
];

export default function creativePreviewRoutes($stateProvider) {
  $stateProvider.state('creativePreview', {
    abstract: true,
    url: '/?site?deviceType',
    template: creativePreviewLayoutTpl,
    controller: 'LayoutController',
    controllerAs: 'layoutCtrl',
    resolve: {
      partner: [
        'CurrentPartnerService',
        '$translate',
        (CurrentPartnerService, $translate) =>
          CurrentPartnerService.get().then(partner => {
            $translate.use(partner.language);
            return partner;
          })
      ],
      partnerSites: [
        'SitesService',
        SitesService => SitesService.fetchPartnerSites()
      ]
    }
  });

  $stateProvider.state('creativePreview.home', {
    controller: 'HomeController',
    controllerAs: 'homeCtrl',
    resolve: {
      event: [
        () => {
          setTimeout(() => {
            window.dispatchEvent(new window.CustomEvent('str-nag-root'));
          }, 0);
        }
      ]
    },
    template: creativePreviewHomeTpl,
    url: ''
  });

  $stateProvider.state('creativePreview.campaigns', {
    abstract: true,
    url: 'campaigns',
    template: '<div ui-view></div>'
  });

  $stateProvider.state('creativePreview.shared', {
    url: 'demo/:id/:siteName?site',
    params: { siteName: { value: null, squash: true } },
    template: creativePreviewSharedTpl,
    controller: 'SavedController',
    controllerAs: 'showVm',
    data: { type: 'demo', shared: true },
    resolve: {
      creativeResponse: fetchCreative,
      partner: fetchCurrentPartner
    }
  });

  $stateProvider.state('creativePreview.saved', {
    url: 'share/:id',
    template: creativePreviewSharedTpl,
    controller: 'SavedController',
    controllerAs: 'showVm',
    data: { navState: 'shared', type: 'demo' },
    resolve: {
      creativeResponse: fetchCreative,
      partner: fetchCurrentPartner
    }
  });

  $stateProvider.state('creativePreview.edit.group', {
    url: '/saved/:id/group',
    template: creativePreviewSavedTpl,
    controller: 'SavedController',
    controllerAs: 'savedController',
    data: { navState: 'edit', type: 'group' },
    resolve: {
      creativeResponse: fetchCreativeGroup,
      partner: fetchCurrentPartner
    }
  });

  $stateProvider.state('dsp', {
    abstract: true,
    url: '/dsp',
    template: '<div ui-view></div>'
  });

  $stateProvider.state('dsp.home', {
    url: '',
    template: dspHomeTpl,
    controller: 'DspController',
    controllerAs: 'dspVm'
  });

  $stateProvider.state('dsp.appNexus', {
    url: '/appnexus/:id?site',
    template: dspShowTpl,
    controller: 'DspAppNexusController',
    controllerAs: 'dspShowVm',
    data: { type: 'appnexus' }
  });

  // enhanced ads routes
  $stateProvider.state('creativePreview.enhanced', {
    abstract: true,
    url: 'enhanced',
    template: '<div ui-view></div>'
  });

  $stateProvider.state('creativePreview.enhanced.example', {
    url: '/example/:id',
    template: enhancedExampleTpl
  });

  $stateProvider.state('creativePreview.enhanced.index', {
    url: '/ads',
    template: enhancedAdsIndexTpl
  });

  $stateProvider.state('creativePreview.enhanced.show', {
    url: '/:id',
    template: enhancedAdsShowTpl
  });
}

creativePreviewRoutes.$inject = ['$stateProvider'];
